import {commonReducers} from '@gisatcz/ptr-state';
import ActionTypes from '../../../../constants/ActionTypes';

const INITIAL_STATE = {
	activeKey: 'sentinel2',
	byKey: {
		landsat: {
			key: 'landsat',
			data: {
				nameDisplay: 'Landsat',
			},
		},
		sentinel2: {
			key: 'sentinel2',
			data: {
				nameDisplay: 'Sentinel 2',
			},
		},
	},
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ActionTypes.WORLD_WATER.WATER_LEVEL.SATELLITES.SET_ACTIVE_KEY:
			return commonReducers.setActive(state, action);
		default:
			return state;
	}
};
